export default "__VITE_ASSET__B$R4OkHj__"